module.exports = __webpack_public_path__ + "static/venice20894-02d4557afc67ad71140ce94437e1cd12.webp";